import {useIsHomePage} from '@aboutyou/router';
import {useDiscounts} from '../../../backend-services/Campaigns/hooks/useDiscounts';
import {useIsGenericWebCouponBannerEnabled} from '../../WebCouponBanner/utils/useIsGenericWebCouponBannerEnabled';

export const useShowSlideInWebCouponBanner = () => {
  const isGenericWebCouponBannerEnabled = useIsGenericWebCouponBannerEnabled();
  const isBrowsePage = useIsHomePage();
  // coupons are the lowest in the campaign framework:
  // if a user has an active PD, PX Major, PX Minor, Crazy bet, App flash Sale is running, Coupon promotions are not shown
  const {data} = useDiscounts();

  return (
    isGenericWebCouponBannerEnabled &&
    isBrowsePage &&
    data?.discounts?.length === 0
  );
};
